import { toast } from 'react-toastify'

export default class Status {
  set_toast = (type, message) => {
    this.type = type
    this.message = message
  }

  show_toast = () => {
    if (
      ['success', 'info', 'warn', 'error'].find((i) => i === this.type) &&
      this.message
    ) {
      toast[this.type](this.message)
    }
  }
}
